import { gql } from "@apollo/client";

export const GET_INVITED = gql`
  query getInvated {
    getInvated {
      RegisterId
      Email
      State
      UserOrganizationId
      UserGroupType {
        Name
      }
      InviterUser {
        UserId
        Firstname
        Lastname
        Email
        Phone
        UserState
      }
    }
  }
`;

export const SEND_INVITE = gql`
  mutation sendInvite(
    $Email: String!
    $InvitedUserOrganizationId: Int
    $InvitedUserOrganizationName: String
    $UserGroupTypeId: Int!
    $Expires: Date!
  ) {
    sendInvite(
      data: {
        Email: $Email
        InvitedUserOrganizationId: $InvitedUserOrganizationId
        InvitedUserOrganizationName: $InvitedUserOrganizationName
        UserGroupTypeId: $UserGroupTypeId
        Expires: $Expires
      }
    ) {
      success
    }
  }
`;

export const VALIDATE_REGISTER = gql`
  mutation validateRegister($hash: String!) {
    validateRegister(data: { hash: $hash }) {
      success
    }
  }
`;
